import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { MergeSource } from '../../decorators/decorators/merge.source';
import { AccountMergeData, AccountMergeSchema } from '../data/account.merge.data';
import { ContactFullMergeData, ContactFullMergeSchema } from '../data/contact.full.merge.data';

@MergeDataset({
    entity: ActivityEntityName.Account,
})
export class AccountMergeDataset {
    @MergeSource({
        schema: AccountMergeSchema,
        ignoreFields: ["taxId"]
    })
    account: AccountMergeData;

    @MergeSource({
        schema: ContactFullMergeSchema,
        ignoreCustomFields: true,
        ignoreFields: ["jobTitle"]
    })
    primaryContact: ContactFullMergeData;
}